/** A section of the help page and its anchor; `children` are listed under it in the table of contents. */
export interface ViewerHelpSection {
  readonly id: string;
  readonly title: string;
  readonly children?: readonly ViewerHelpSection[];
}

/** The table of contents of the help page, in page order. Every id is the anchor of a heading in the template. */
export const VIEWER_HELP_SECTIONS: readonly ViewerHelpSection[] = [
  { id: 'overview', title: 'What the viewer is for' },
  { id: 'first-load', title: 'Opening a scene and loading' },
  { id: 'desktop', title: 'Navigation with mouse and keyboard' },
  { id: 'touch', title: 'Navigation on phones and tablets' },
  { id: 'toolbar', title: 'The toolbar' },
  {
    id: 'tabs',
    title: 'Side panel tabs',
    children: [
      { id: 'tab-structure', title: 'Structure' },
      { id: 'tab-viewpoints', title: 'Viewpoints' },
      { id: 'tab-quality', title: 'Quality' },
      { id: 'tab-settings', title: 'Settings' },
      { id: 'tab-scene-debug', title: 'Scene debug (FPS)' },
      { id: 'tab-tools', title: 'Tools' },
    ],
  },
  { id: 'client-cache', title: 'Client cache' },
  { id: 'showcases', title: 'Showcases' },
];
